export default __webpack_public_path__ + "first-icon.svg";